module.exports = __webpack_public_path__ + "img/elo.42274f50.png";